import { ComponentHeader } from '../shared/ComponentHeader'
import { ComponentTitle } from '../shared/ComponentTitle'
import clsx from 'clsx'
// import { ComponentActionsContainer } from '../shared/ComponentActionsContainer'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { getComponentHeights } from '../utils'
import { FileManagerDataSchema, FileManagerUISchema } from './types'
import { useGetLandingFiles } from './useGetLandingFiles'
import { FileManagerTreeTable } from './FileManagerTreeTable'

export function FileManagerContent({
  uiSchema,
  dataSchema,
  tileFilters,
}: {
  uiSchema: FileManagerUISchema
  dataSchema: FileManagerDataSchema
  tileFilters?: React.ReactNode
}) {
  const { title = undefined, description = undefined, emphasizeHeader } = uiSchema
  const { namespace, acceptedFormats, maxFileSizeMb } = dataSchema
  const { data: landingFiles } = useGetLandingFiles(namespace ?? '')
  const hasHeader = !!title && !!tileFilters
  const { contentHeight } = getComponentHeights(emphasizeHeader, hasHeader)
  return (
    <div className="flex h-full flex-col">
      {hasHeader && (
        <ComponentHeader>
          <ComponentTitle title={title} description={description} />
          {tileFilters}
        </ComponentHeader>
      )}
      <ScrollArea className={clsx({ 'pt-5': hasHeader })} style={{ height: contentHeight }}>
        <FileManagerTreeTable
          files={landingFiles?.files ?? []}
          namespace={namespace ?? ''}
          acceptedFormats={acceptedFormats}
          maxFileSizeMb={maxFileSizeMb}
        />
      </ScrollArea>
    </div>
  )
}
